import script from "./settle.vue?vue&type=script&setup=true&lang=js"
export * from "./settle.vue?vue&type=script&setup=true&lang=js"

import "./settle.vue?vue&type=style&index=0&id=29a25ea2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a25ea2"]])

export default __exports__